import { LabTest } from "@domain/lab";
import { DataAPI_Base, GetAPI_Base } from "../base";

class GetAPI_LabTests extends GetAPI_Base<LabTest> {
	constructor() {
		super("lab-tests", LabTest);
	}
}

export class LabTestsAPI extends DataAPI_Base<LabTest> {
	get: GetAPI_LabTests;
	constructor() {
		super("lab-tests", LabTest);
		this.get = new GetAPI_LabTests();
	}
}
